"use client";

import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Bightheplumber Limited",
  quote: "We have subcontracted this electrical company on numerous energy upgrade projects and have always been impressed by their professionalism, reliability, and quality of work. Their team consistently delivers to a high standard, communicates effectively, and works efficiently to meet project deadlines. We would confidently recommend their services for electrical and energy retrofit works.",
  rating: 5,
  position: ""
}, {
  author: "Linda Macdonald",
  quote: "I have to say what a lovely chap!! And to have so many young lads and a lady learning from him was amazing. A fantastic job done. He even fitted a light for me free of charge, much appreciated. I will definitely be calling on Anthony again and I would highly recommend him. Thank you again for all your hard work.",
  rating: 5,
  position: ""
}, {
  author: "Jessica Brown",
  quote: "Highly recommend Anthony. Great communication, hardworking and friendly. Thank you so much for your hard work!",
  rating: 5,
  position: ""
}, {
  author: "Hannah Redmond",
  quote: "Highly recommend Anthony for any electrical needs. Fantastic work, always in contact and on time. Lovely guy to deal with and very affordable.",
  rating: 5,
  position: ""
}, {
  author: "Luca Kelly",
  quote: "Highly recommend AD Electrical. Punctual, professional and efficient.",
  rating: 5,
  position: ""
}, {
  author: "David Carton",
  quote: "Happy to recommend. Reasonable price, punctual and very professional.",
  rating: 5,
  position: ""
}];
export default function VocesDelVecindario() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223618" id="client-success-stories" className="bg-background text-foreground py-24 md:py-32 overflow-hidden relative dark" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex items-center justify-center">
        <svg width="600" height="600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.5">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      </div>

      <div className={`container mx-auto px-4 transition-all duration-1000 ease-out relative z-10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center justify-center text-center px-12 md:px-24 py-8">
                    <Quote className={`size-12 md:size-16 mb-8 rotate-180 shrink-0 ${i === 1 ? "text-ring/60" : "text-ring/20"}`} />
                    
                    <blockquote className="mb-10">
                      <p className="font-default italic font-medium text-2xl md:text-4xl lg:text-5xl text-foreground leading-relaxed md:leading-snug tracking-tight">
                        "{testimonial.quote}"
                      </p>
                    </blockquote>
                    
                    <div className="flex flex-col items-center gap-3">
                      <cite className="font-default font-bold text-lg md:text-xl text-foreground not-italic">
                        {testimonial.author}
                      </cite>
                      <div className="flex gap-1 mb-1">
                        {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} className="size-4 fill-ring text-ring" />)}
                      </div>
                      
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="bg-card/80 hover:bg-card border-border shadow-md" />
              <CarouselNext className="bg-card/80 hover:bg-card border-border shadow-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}